// extracted by mini-css-extract-plugin
module.exports = {"item":"CaseHistoryListItem_item__oM9QJ","thumbnail":"CaseHistoryListItem_thumbnail__3nYGx","info":"CaseHistoryListItem_info__2J87X"};